import { gql } from '@apollo/client';
import { NoteFragments } from '../../fragments/note/note.fragments';

//TODO: prendre aussi les quizToNotes par classe (${NoteFragments.fragments.QuizToNote})
export const QUERY_GET_MY_NOTE_IN_CLASSE = gql`
  query GetMyNoteInClasse($id: ID!) {
    getMyNoteInClasse(userId: $id) {
      note {
        id
        attributes {
          ...Quantite
          ...ChallengeNote
          updatedAt
        }
      }
      quizToNotes {
        id
        attributes {
          ...NoteDesQuiz
        }
      }
    }
  }
  ${NoteFragments.fragments.ChallengeNote}
  ${NoteFragments.fragments.Quantite}
  ${NoteFragments.fragments.QuizToNote}
`;
